import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import SelectionListItem from '@wix/da-ds/pkg/SelectionList/SelectionListItem';
import { DeviationResourceType } from '../../../types/deviation';
var EditTier = function (_a) {
    var deviation = _a.deviation, editTier = _a.editTier;
    var t = useTranslation().t;
    return (React.createElement(SelectionListItem, { label: t('common.edit'), onClick: editTier, biData: {
            evid: BiEventType.TIER_EDIT_CLICK,
            typeid: DeviationResourceType.TIER,
            itemid: deviation.deviationId,
        } }));
};
EditTier.displayName = 'EditTier';
export default EditTier;
//# sourceMappingURL=EditTier.js.map